import { HTMLMotionProps, motion } from 'framer-motion';
import { ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { backdropAnimation } from '../helpers/backdrop.animations';

interface BackdropProps extends HTMLMotionProps<'div'> {
    show: boolean;
    onClick?: () => void;
    ref?: ForwardedRef<any>;
}

const Backdrop = forwardRef<HTMLDivElement, BackdropProps>((props, ref) => {
    const { show, onClick, className, ...rest } = props;

    if (!show) return null;

    return (
        <motion.div
            {...rest}
            {...backdropAnimation}
            ref={ref}
            className={twMerge(
                'fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black/30',
                className
            )}
            onClick={onClick}
        ></motion.div>
    );
});

export default Backdrop;
